// extracted by mini-css-extract-plugin
export default {"base":"CategoryPicker_base__0evrS","boAdminCheckbox":"CategoryPicker_boAdminCheckbox__eBuFh"};